// @flow
import React, { Component } from 'react'
import { setInputSelection } from '../../shared/dom.utils'
import { translateFunc, translations } from '../../shared/localize'
import ErrorText from '../controls/ErrorText'
import _ from 'lodash'
import styled from 'styled-components'
import type { ComponentType } from 'react'
import matchesNotFloat from '../controls/FloatValueMatcher'
import LabeledWrapper from './LabeledWrapper'

const Input = styled.input`
  text-align: right;
`
const InputBlock = styled.div`
  display: inline-block;
`
const Hint = styled.div`
  display: inline-block;
  padding-left: 15px;
`
const HintComment: ComponentType<{ mode: 'error' | 'warning' | 'ok' }> = (styled.div`
  font-weight: bold;

  color: ${({ mode }: Object) => {
    if (mode === 'error') return '#f60000'
    if (mode === 'warning') return '#ff9025'
    if (mode === 'ok') return '#58ae58'
    return ''
  }};
`: any)

const t = translateFunc(translations.audience_edit.price_input)

type Props = {|
  value: string,
  min: number,
  maxAlert: number,
  minRecommended: number,
  effectivePrice: number,
  errors: Array<string>,
  showLabel?: boolean,
  isLoading: boolean,
  onChange?: (string) => void,
  autoFocus?: boolean,
  hide?: boolean,
  paymentType?: string
|}

type State = {|
  errors: Array<string>
|}

export default class PriceInput extends Component<Props, State> {
  input: Object

  constructor(props: Props) {
    super(props)

    this.state = { errors: props.errors }
  }

  componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(prevProps.errors, this.props.errors)) {
      this.setState({ errors: this.props.errors })
    }
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      const length = this.input.value.length
      setInputSelection(this.input, length, length)
    }
  }

  render() {
    const { showLabel, autoFocus, hide } = this.props

    if (hide) return null

    return (
      <LabeledWrapper label={t('label')} hideLabel={!showLabel}>
        <InputBlock>
          <Input
            value={this.props.value}
            onChange={(e) => this.changed(e)}
            className="input-item input-item_small"
            type="text"
            id="audience_price"
            autoFocus={autoFocus}
            ref={(el: any) => {
              this.input = el
            }}
          />
          ₽<Hint>{this.renderComment()}</Hint>
          <ErrorText errors={this.state.errors} />
        </InputBlock>
      </LabeledWrapper>
    )
  }

  changed(e: Object) {
    const value = e.target.value
    const { onChange } = this.props

    if (matchesNotFloat(value)) return

    onChange && onChange(value)
    this.setState({ errors: [] })
  }

  // TODO: Imperative style!
  setErrors(errors: Array<string>) {
    this.setState({ errors })
  }

  renderComment() {
    const { isLoading, min, maxAlert, minRecommended, effectivePrice, paymentType } = this.props
    let val = parseFloat(this.props.value)

    if (isLoading || isNaN(val)) {
      return null
    } else if (val < min) {
      return (
        <HintComment mode="error" className="t-Price__hint-text">
          {t('gt_value_msg')} {min} ₽
        </HintComment>
      )
    } else if (paymentType === 'cpm' && val < maxAlert) {
      return (
        <div>
          <HintComment mode="error" className="t-Price__hint-text">
            {t('price_alert_msg')}
          </HintComment>
          <HintComment mode="error" className="t-Price__hint-text">
            {t('price_alert_warning')}
            <a href="/ru/blog/min-price/" target="_blank">
              {t('price_alert_link')}
            </a>
          </HintComment>
        </div>
      )
    } else if (val < minRecommended) {
      return (
        <HintComment mode="error" className="t-Price__hint-text">
          {t('rare_showing_msg')}
        </HintComment>
      )
    } else if (val < effectivePrice) {
      return (
        <HintComment mode="warning" className="t-Price__hint-text">
          {t('not_in_all_providers_showed_msg')}
        </HintComment>
      )
    } else {
      return (
        <HintComment mode="ok" className="t-Price__hint-text">
          ОК
        </HintComment>
      )
    }
  }
}
